<template>
  <div class="mb-filtro__estaciones">
    <span>Mostrar</span>
    <ClientOnly>
      <button
        v-for="l in limitList"
        :key="l"
        type="button"
        :class="['mb-btn', limite === l ? 'activo' : '']"
        @click="emit('toggle-limite', l)"
      >
        {{ l !== 0 ? `PROX ${l}` : 'TODOS' }}
      </button>
      <template #fallback>
        <button v-for="l in limitList" :key="l" type="button" class="mb-btn">
          {{ l !== 0 ? `PROX ${l}` : 'TODOS' }}
        </button>
      </template>
    </ClientOnly>
  </div>
</template>
<script setup lang="ts">
const props = withDefaults(defineProps<{ limite: number }>(), {
  limite: 10,
});

const limitList = [0, 10, 5];

const emit = defineEmits<{
  (e: 'toggle-limite', limite: number): void;
}>();
</script>
